import React from 'react'
import { Element } from '../../../../../common/html/element'
import { Row } from '../../../../../common/table/Row'
import { TitleRow } from './TitleRow'

export const TbodyTable = ({ ids, getDataFromRedux, schema }) => {
  return (
    <tbody>
      {ids.map((id, rowIndex) => {
        return (
          <React.Fragment key={id}>
            <Element elementName="tr">
              <TitleRow getDataFromRedux={getDataFromRedux} rowId={id} />
            </Element>
            <Row
              key={id}
              getDataFromRedux={getDataFromRedux}
              rowId={id}
              rowIndex={rowIndex}
              schema={schema}
            />
          </React.Fragment>
        )
      })}
    </tbody>
  )
}
